export const StepPasswordLock = require("./StepPasswordLock").default
export const StepPermissionLock = require("./StepPermissionLock").default
export const StepStartLock = require("./StepStartLock").default
export const RegisterLock = require("./RegisterLock").default
